module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-auto p-0"
  }, [_c('b-nav', [_vm._l((_vm.$route.meta.breadcrumbObject), function(linkObj, linkTitle) {
    return _c('b-nav-item', {
      key: linkTitle
    }, [_c('router-link', {
      attrs: {
        "to": linkObj
      }
    }, [_vm._v("\n            " + _vm._s(linkTitle) + "\n          ")]), _vm._v(" "), _c('span', [_vm._v("/")])], 1)
  }), _vm._v(" "), _vm._l((_vm.breadcrumbs), function(linkObj) {
    return _c('b-nav-item', [_c('router-link', {
      attrs: {
        "to": linkObj
      }
    }, [_vm._v("\n            " + _vm._s(linkObj.text) + "\n          ")]), _vm._v(" "), _c('span', [_vm._v("/")])], 1)
  })], 2)], 1), _vm._v(" "), (_vm.linkText) ? _c('div', {
    staticClass: "col link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.routeName
      }
    }
  }, [_vm._v(_vm._s(_vm.linkText))])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0afaff32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/header-area/HeaderBreadcrumbsComponent.vue
// module id = 1384
// module chunks = 1